import { gql } from 'graphql-tag';
export const sendThemeFeedback = gql`
  mutation sendThemeFeedback($input: SendTagFeedbackInput!) {
    sendOecTagFeedback(input: $input) {
      success
    }
  }
`;